const header = {
  homepage: '',
  title: '',
}

const about = {
  name: 'Mohammad Tavakoli',
  role: 'Computer Engineer',
  description: 'I am enthusiastic about artificial intelligence and software engineering',
  resume: 'https://github.com/mohammadtavakoli78/mohammadtavakoli78.github.io/raw/master/public/CV.pdf',
  social: {
    linkedin: 'https://www.linkedin.com/in/mohamadtavakoli/',
    github: 'https://github.com/mohammadtavakoli78',
    telegram: 'https://www.t.me/Mohammad_ta78'
  },
}

const relevantCourseWork = [
  {
    name: 'Data Mining',
    gradeGpa: '4',
    grade: '19.4'
  },
  {
    name: 'Computational Intelligence',
    gradeGpa: '4',
    grade: '20'
  },
  {
    name: 'Information Retrieval',
    gradeGpa: '4',
    grade: '19.38'
  },
  {
    name: 'Artificial Intelligence',
    gradeGpa: '4',
    grade: '18.8'
  },
  {
    name: 'Algorithm Design',
    gradeGpa: '4',
    grade: '19.5'
  },
  {
    name: 'Internet of Things',
    gradeGpa: '4',
    grade: '19.89'
  },
  {
    name: 'Web Programming',
    gradeGpa: '4',
    grade: '20'
  },
  {
    name: 'Computer Networks',
    gradeGpa: '4',
    grade: '19.75'
  },
  {
    name: 'Advanced Programming',
    gradeGpa: '4',
    grade: '20'
  },
  {
    name: 'Cloud Computing',
    gradeGpa: '4',
    grade: '19'
  },
  {
    name: 'Software Engineerig II',
    gradeGpa: '4',
    grade: '20'
  },
  {
    name: 'Microprocessor and Assembly Language',
    gradeGpa: '4',
    grade: '20'
  },
]

const projects = [
  {
    name: 'Data Mining',
    description: 'This repository contains four different projects.',
    task: [
      'First project, is about preprocessing that we use pandas and Scikit-learn for this purpose. The dataset we use is iris-dataset.',
      'Second project, is about creating a Neural Network and we train the model for two datasets: make circles and fashion mnist.',
      'Third project, is about Association Rules and also Clustering, There are two different projects',
      'Final project, we train a model with a dataset which has more than 70k records and we should decide whether a person has a special disease or not, for this project we use XGBoost that is a decision tree.',
    ],
    stack: ['Python', 'Scikit-learn', 'pandas', 'XGBoost', 'Neural Network', 'Association Rules'],
    sourceCode: 'https://github.com/mohammadtavakoli78/Data-Mining',
  },
  {
    name: 'Computational Intelligence',
    description: 'This repository contains four different projects.',
    task: [
      'At first Project we should Classify Six Fruits with the help of Neural Networks.',
      'At second Project we should balance Inverted Pendulum with the help of Fuzzy System.',
      'At third Project we should play a game name Snail Jumper with the help of Evolutionary Algorithms.',
      'At fourth Project we should manage a Watering Plants System with the help of Fuzzy System.',
    ],
    stack: ['Python', 'Neural Network', 'Fuzzy System', 'Evolutionary Algorithms'],
    sourceCode: 'https://github.com/mohammadtavakoli78/Computational-Intelligence',
  },
  {
    name: 'Artificial Intelligence',
    description: 'This repository contains four different projects.',
    task: [
      'The first one is a game implemented with python and there is a gui, for this game i used search algorithms like: IDS, BBFS and A*.',
      'The second project which is implemented with python, we learn a game and play new levels successfully. The algorithm used is genetic algorithm.',
      'The third project which is implemented with python, we should complete a simple sudoku and the algorithm used is backtracking.',
      'The forth project which is implemented with python, we should decide whether a comment is positive or negative and we use NLP for this purpose.',
    ],
    stack: ['Python', 'search algorithms', 'genetic algorithm', 'backtracking', 'NLP'],
    sourceCode: 'https://github.com/mohammadtavakoli78/Artificial-Intelligence',
  },
  {
    name: 'Information Retrieval',
    description: 'In this project i implement a search engine using various algorithms like: tf-idf, Word Embedding, Inverted Index and also in phase three i use KNN and K-means for clustering and classifying that leads to boost speed of retrieving documents.',
    task: [
    ],
    stack: ['Python', 'Search Engine', 'Word Embedding', 'K-means', 'KNN', 'Inverted Index'],
    sourceCode: 'https://github.com/mohammadtavakoli78/Informations-Retrieval',
  },
  {
    name: 'Cloud Computing',
    description: 'This repository contains four different projects.',
    task: [
      'First project makes us get acquainted with some Cloud Services like: Speech to Text, Natural Language Understanding and Language Translator.',
      'Second project makes us get acquainted with Docker and basics of Kubernetes.',
      'Third project makes us get acquainted with Hadoop and basics of MapReduce.',
      'Fourth project makes us get acquainted with Docker and Kubernetes.',
    ],
    stack: ['Docker', 'Kubernetes', 'Hadoop', 'Yarn', 'Python', 'Php', 'Djagno', 'PostgreSQL'],
    sourceCode: 'https://github.com/mohammadtavakoli78/Cloud-Computing',
  },
  {
    name: 'Web Programming',
    description: 'This is final project of web programming which is implementing an online shop that we can create account, login to account, see products, buy products, filter them, search for a specific product and also we should have an admin panel that we can edit products, add products, see users information and ....',
    task: [
    ],
    stack: ['Reactjs', 'Nextjs', 'JavaScript', 'Spring', 'Java', 'SCSS'],
    sourceCode: 'https://github.com/mohammadtavakoli78/Web-Programming',
  },
  {
    name: 'Programming Languages',
    description: 'This is final project of Programming Languages that we should write an interpreter for NUMEX with racket.',
    task: [
    ],
    stack: ['Racket', 'NUMEX', 'Interpreter'],
    sourceCode: 'https://github.com/mohammadtavakoli78/Programming-Languages',
  },
  {
    name: 'Bookapo',
    description: 'Bookapo is a company which provides eBooks and users can buy subscriptions and have access to summary of diverse books.',
    task: [
      'Implemented the front end of the Bookapo website using reactjs',
      'Used docker for containerizing different applications.',
      'Using version control systems such as Git to organize modifications and assign tasks.'
    ],
    stack: ['Reactjs', 'Nextjs', 'JavaScript', 'SCSS'],
    sourceCode: 'https://bookapo.com/',
  }
  
]

const workExperience = [
  {
    title: 'Digikala',
    date: 'Jan 2022 – May 2022',
    site: 'https://digikala.com/',
    position: 'Software Engineer',
    location: 'Tehran, Iran',
    description: 'Digikala is the most reliable and bigest IT company in iran which has more than 9000 employees and getting hired at this company is difficult. Digikala has more than 70 million users by the aid of cutting-edge technologies.',
    tasks: [
      'Worked with large and scalable databases and created complex and efficient queries.',
      'Assisted in development of a service written in PHP (Symfony) which was responsible for getting diverse reports to users.',
      'Used docker for containerizing different applications and used kubernetes for scaling pods.',
      'Collaborated with team members using version control systems such as Git to organize modifications and assign tasks.',
    ]
  },
  {
    title: 'Narvan Startup Studio',
    date: 'June 2021 – Jan 2022',
    site: 'https://narvanstartupstudio.com/',
    position: 'Backend Developer',
    location: 'Tehran, Iran',
    description: 'Narvan is a startup for trading stocks for users and gives news about market and price of different coins and currencies and teaches methods of trading stocks to gain a good profit.',
    tasks: [
      'Assisted in development of a service written in Python (flask) which was responsible for getting news of market and price of different currencies to users.',
      'Worked with gRPC, Elasticsearch, Prometheus, PostgreSQL, Nginx, Kafka.',
      'Used docker for containerizing different applications and used kubernetes for scaling pods.',
      'Collaborated with team members using version control systems such as Git to organize modifications and assign tasks.',
    ]
  },
  {
    title: 'Bookapo',
    date: 'Aug 2020 – June 2021',
    site: 'https://bookapo.com/',
    position: 'Frontend Developer',
    location: 'Tehran, Iran',
    description: 'Bookapo is a company which provides eBooks and users can buy subscriptions and have access to summary of diverse books.',
    tasks: [
      'Implemented the front end of the Bookapo website using reactjs.',
      'Used docker for containerizing different applications.',
      'Collaborated with team members using version control systems such as Git to organize modifications and assign tasks.',
    ]
  },
]

const teachingExperience = [
  {
    title: 'Teaching Assistant, Data Mining',
    date: 'Sep. 2022 – Jan. 2023',
    tasks: [
      'Designing homeworks and projects for students',
      'Answering student’s questions.',
      'Evaluating student’s projects and homeworks.'
    ],
    professorName: 'Maryam Amirmazlaghani',
    professorLink: 'https://scholar.google.com/citations?hl=en&user=gxbTUfEAAAAJ'
  },
  {
    title: 'Teaching Assistant, Cloud Computing',
    date: 'Sep. 2022 – Jan. 2023',
    tasks: [
      'Designing homeworks and projects for students',
      'Answering student’s questions.',
      'Evaluating student’s projects and homeworks.'
    ],
    professorName: 'Ahmad Javadi',
    professorLink: 'https://scholar.google.com/citations?hl=en&user=Va7RTUsAAAAJ'
  },
  {
    title: 'Teaching Assistant, Internet of Things',
    date: 'Sep. 2022 – Jan. 2023',
    tasks: [
      'Designing homeworks and projects for students',
      'Answering student’s questions.',
      'Evaluating student’s projects and homeworks.'
    ],
    professorName: 'Siavash Khorsandi',
    professorLink: 'https://scholar.google.com/citations?hl=en&user=y1zzy74AAAAJ'
  },
  {
    title: 'Teaching Assistant, Computational Intelligence',
    date: 'Feb 2022 – July 2022',
    tasks: [
      'Designing homeworks and projects for students',
      'Answering student’s questions.',
      'Evaluating student’s projects and homeworks.'
    ],
    professorName: 'Mohammad Mehdi Ebadzadeh',
    professorLink: 'https://scholar.google.com/citations?hl=en&user=080Y_lUAAAAJ'
  },
  {
    title: 'Teaching Assistant, Technical research and Presentation',
    date: 'Feb 2022 – July 2022',
    tasks: [
      'Designing homeworks for students.',
      'Answering student’s questions.',
      'Evaluating student’s homeworks.'
    ],
    professorName: 'Reza Safabakhsh',
    professorLink: 'https://scholar.google.com/citations?hl=en&user=zFsdqo8AAAAJ'
  },
  {
    title: 'Teaching Assistant, Algorithm Design',
    date: 'Feb 2022 – July 2022',
    tasks: [
      'Designing homeworks for students.',
      'Answering student’s questions.',
      'Evaluating student’s homeworks.'
    ],
    professorName: 'Alireza Bagheri',
    professorLink: 'https://scholar.google.com/citations?hl=en&user=MYvL3dMAAAAJ'
  },
  {
    title: 'Teaching Assistant, Microprocessor and Assembly Language',
    date: 'Feb 2022 – July 2022',
    tasks: [
      'Designing homeworks for students.',
      'Answering student’s questions.',
      'Evaluating student’s homeworks.'
    ],
    professorName: 'Hamed Farbeh',
    professorLink: 'https://scholar.google.com/citations?hl=en&user=PAZOYiAAAAAJ'
  },
  {
    title: 'Teaching Assistant, Algorithm Design',
    date: 'Sep 2021 – Jan 2022',
    tasks: [
      'Designing homeworks for students.',
      'Answering student’s questions.',
      'Evaluating student’s homeworks.'
    ],
    professorName: 'Alireza Bagheri',
    professorLink: 'https://scholar.google.com/citations?hl=en&user=MYvL3dMAAAAJ'
  },
  {
    title: 'Teaching Assistant, Web Programming',
    date: 'Sep 2021 – Jan 2022',
    tasks: [
      'Designing homeworks and projects for students',
      'Answering student’s questions.',
      'Evaluating student’s projects and homeworks.'
    ],
    professorName: 'Parham Alvani',
    professorLink: ''
  },
  {
    title: 'Teaching Assistant, Computer Networks',
    date: 'Jan 2021 – July 2021',
    tasks: [
      'Designing homeworks and projects for students',
      'Answering student’s questions.',
      'Evaluating student’s projects and homeworks.'
    ],
    professorName: 'Masoud Sabaei',
    professorLink: 'https://scholar.google.com/citations?hl=en&user=aIiC_6UAAAAJ'
  },
  {
    title: 'Teaching Assistant, Computer Networks',
    date: 'Jan 2021 – July 2021',
    tasks: [
      'Designing homeworks and projects for students',
      'Answering student’s questions.',
      'Evaluating student’s projects and homeworks.'
    ],
    professorName: 'Pooya Hejazi',
    professorLink: 'https://scholar.google.com/citations?hl=en&user=ZBUM5E0AAAAJ'
  },
]

const skills = [
  {
    title: 'Programming Languages',
    skill: [
      'C/C++',
      'Java',
      'Python',
      'Php',
      'Go',
      'racket',
      'Lisp',
      'ML',
    ]
  },
  {
    title: 'ML & Deep Learning',
    skill: [
      'Pytorch',
      'Keras',
      'Tensorflow',
      'Numpy',
      'Pandas',
      'Scikit-learn',
    ]
  },
  {
    title: 'Web Programming',
    skill: [
      'Flask',
      'Django',
      'HTML/CSS',
      'JavaScript',
      'Reactjs',
      'Nextjs',
      'Node.js',
      'jQuery'
    ]
  },
  {
    title: 'Database',
    skill: [
      'MySQL',
      'PostgreSQL',
      'MongoDB',
      'SQLite',
      'influxDB'
    ]
  },
  {
    title: 'Application Development',
    skill: [
      'Android',
      'React-Native'
    ]
  },
  {
    title: 'Operating Systems',
    skill: [
      'Windows',
      'Linux(Ubuntu)'
    ]
  },
  {
    title: 'Misc',
    skill: [
      'Docker',
      'Kubernetes',
      'Elastic Search',
      'LaTex',
      'Arduino',
      'Verilog',
      'VHDL'
    ]
  },
]

const education = [
  {
    name: 'Amirkabir University of Technology',
    date: 'SEP 2018 - PRESENT',
    description: 'Bachelor of Science in Computer Engineering',
    location: 'Tehran, Iran',
    gpa: 'GPA : 3.72/4 (17.86/20)',
  },
  {
    name: 'Boalisina',
    date: 'SEP 2014 - JUN 2018',
    description: 'High school | Diploma in mathematics and physics',
    location: 'Tehran, Iran',
    gpa: 'GPA : 4/4 (19.86/20)',
  }
]

const interests = [
  'Computer Vision',
  'Machine Learning',
  'Deep Learning',
  'Data Mining',
  'Software Engineering',
]

const honors = [
  'Ranked 255 among more than 150,000 participants in National Entrance Exam for Undergraduate State Universities, Iran, 2018',
  'Selected as an Outstanding Student (GPA based) and among top ranked undergraduates, Amirkabir University of Technology'
]

const references = [
  {
    name: 'Reza Safabakhsh, Professor',
    description: 'Member of Artificial Intelligence Group, CE, AUT',
    email: 'safa@aut.ac.ir',
    homepage: 'https://aut.ac.ir/cv/2455/REZA-SAFABAKHSH',
    scholar: 'https://scholar.google.com/citations?hl=en&user=zFsdqo8AAAAJ'
  },
  {
    name: 'Mohammad rahmati, Professor',
    description: 'Member of Artificial Intelligence Group, CE, AUT',
    email: 'rahmati@aut.ac.ir',
    homepage: 'https://aut.ac.ir/cv/2416/MOHAMMAD-RAHMATI',
    scholar: 'https://scholar.google.com/citations?hl=en&user=EYk7M80AAAAJ'
  },
  {
    name: 'Mohammad Mehdi Ebadzadeh, Professor',
    description: 'Member of Artificial Intelligence Group, CE, AUT',
    email: 'ebadzadeh@aut.ac.ir',
    homepage: 'https://aut.ac.ir/cv/2130/MOHAMMAD-MEHDI-EBADZADEH',
    scholar: 'https://scholar.google.com/citations?hl=en&user=080Y_lUAAAAJ'
  },
  {
    name: 'Maryam Amirmazlaghani, Associate Professor',
    description: 'Member of Artificial Intelligence Group, CE, AUT',
    email: 'mazlaghani@aut.ac.ir',
    homepage: 'https://aut.ac.ir/cv/2296/MARYAM-AMIR-MAZLAGHANI',
    scholar: 'https://scholar.google.com/citations?hl=en&user=gxbTUfEAAAAJ'
  },
  {
    name: 'Siavash Khorsandi, Associate Professor',
    description: 'Member of Computer Networks Group, CE, AUT',
    email: 'khorsandi@aut.ac.ir',
    homepage: 'https://aut.ac.ir/cv/2261/SIAVASH-KHORSANDI',
    scholar: 'https://scholar.google.com/citations?hl=en&user=y1zzy74AAAAJ'
  },
  {
    name: 'Masoud Sabaei, Associate Professor',
    description: 'Member of Computer Networks Group, CE, AUT',
    email: 'sabaei@aut.ac.ir',
    homepage: 'https://aut.ac.ir/cv/2446/MASOUD-SABAEI',
    scholar: 'https://scholar.google.com/citations?hl=en&user=aIiC_6UAAAAJ'
  },
  {
    name: 'Hamed Farbeh, Assistant Professor',
    description: 'Member of Computer Networks Group, CE, AUT',
    email: 'farbeh@aut.ac.ir',
    homepage: 'https://aut.ac.ir/cv/2158/HAMED-FARBEH',
    scholar: 'https://scholar.google.com/citations?hl=en&user=PAZOYiAAAAAJ'
  },
  {
    name: 'Alireza Bagheri, Associate Professor',
    description: 'Member of Software Group, CE, AUT',
    email: 'ar_bagheri@aut.ac.ir',
    homepage: 'https://aut.ac.ir/cv/2072/Alireza-Bagheri',
    scholar: 'https://scholar.google.com/citations?hl=en&user=MYvL3dMAAAAJ'
  },
  {
    name: 'Ahmad Javadi, Assistant Professor',
    description: 'Member of Computer Networks Group, CE, AUT',
    email: 'sajavadi@aut.ac.ir',
    homepage: 'https://aut.ac.ir/cv/21291/S.Ahmad-Javadi',
    scholar: 'https://scholar.google.com/citations?hl=en&user=Va7RTUsAAAAJ'
  },
]

const contact = {
  email: 'mohamad.tavakoli7878@gmail.com',
}

export { header, about, projects, skills, contact, education, interests, workExperience, teachingExperience, relevantCourseWork, honors, references }
